const MenuItems = [
  {
    title: 'Accueil',
    url: '/',
    cName: 'nav-links'
  },
  {
    title: 'Galeries Photos',
    url: '/galerie',
    cName: 'nav-links'
  },
  {
    title: 'Infos Pratiques',
    url: '/infos',
    cName: 'nav-links'
  },
  {
    title: "De L'histoire à la Légende",
    url: '/legende',
    cName: 'nav-links'
  },
  {
    title: "Petits bouts d'histoire",
    url: '/histoire',
    cName: 'nav-links'
  },
]

export default MenuItems
